import { Alert, Button } from "antd";
import { Link } from "react-router-dom";
function ProfileMessage({ name, confirmStatus }) {
  if (!name)
    return (
      <Alert
        message="لطفا پروفایل خود را تکمیل کنید."
        type="warning"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
        action={
          <Button size="small" danger>
            <Link to="/profile"> تکمیل پروفایل</Link>
          </Button>
        }
      />
    );
  if (confirmStatus === "PENDING")
    return (
      <Alert
        message="اطلاعات پروفایل شما در حال بررسی است."
        type="info"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
      />
    );
  if (confirmStatus === "ERROR")
    return (
      <Alert
        message="لطفا پروفایل خود را اصلاح کنید."
        type="error"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
        action={
          <Button size="small" danger>
            <Link to="/profile"> اصلاح پروفایل</Link>
          </Button>
        }
      />
    );
 
}

export default ProfileMessage;
